import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridBilantRanduri = _resolveComponent("GridBilantRanduri")!
  const _component_GridBilantFormule = _resolveComponent("GridBilantFormule")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GridBilantRanduri, {
      BilantID: $props.bilant.ID,
      onSelectBilantrand: $options.onBilantRandSelected
    }, null, 8, ["BilantID", "onSelectBilantrand"]),
    _createVNode(_component_GridBilantFormule, {
      BilantRandID: $data.selectedBilantRandID,
      "bilant-data": $props.bilant
    }, null, 8, ["BilantRandID", "bilant-data"])
  ]))
}